/*jshint esversion: 6 */
export const namespaced = true;
import _ from 'lodash';
import Vue from 'vue'
import io from 'socket.io-client';
import router from '@/router.js'
import {DeviceEventBus} from '../../DeviceEventBus'
import helpers from '../../helpers'
import axios from 'axios';


// import store from '../store/store.js'
let counter = 0 
export const state = {
    connected:false,
    loginInfo:null,
    serverURL:"https://eraulive.near.aero/",
    // serverURL:"http://45.79.211.72:8191",
    // serverURL:"http://localhost:8181",
    // serverURL:"http://eraulive.near.aero:8191/",
    socket:null,
    connected2:1,
    pingTimer:null,
    latency:0,
    pingEvery:30000
   

}
export const mutations ={
    SET_Connected(state,payload){
       
       
        state.connected = payload
        Vue.prototype.$connected = state.connected
        // if(!state.connected){
        //     state.socket=null
        // }

        DeviceEventBus.$emit("connectionStatus",{connected: state.connected, connectionType: "none"})
       
    },
   
    SET_Socket(state,payload){
        console.log("SET_Socket", payload)
        state.socket = payload
        Vue.prototype.$socket =state.socket
    },
    SET_Latency(state,latency){
        // console.log("connection:SET_Latency ",latency)
        state.latency=latency
    }

}
export const actions ={
    setConnectionStatus(context,payload){
        context.commit("SET_Connected",payload)
    },
    SetLatency(context,payload){

    },
    async connect(context,payload){
        try {
            /* check if already connected */
            if(!context.state.connected){
            
                const info = await helpers.deviceInfo()
                // Get Token from the server first
                let token = await context.dispatch("getToken",info);
                if(token!=null){
                /* connect to the server */
                    context.state.socket= io(context.state.serverURL, {query:`auth_token=${token}`},{
                        reconnection: true,
                        reconnectionDelay: 1000,
                        reconnectionDelayMax : 5000,
                        reconnectionAttempts: Infinity,
                        autoConnect: true
                    })
                    /*if connection is successful */
                    context.state.socket.on('connect',()=>{
                            
                        context.dispatch("setConnectionStatus",true)
                        context.state.pingTimer= null
                        context.state.pingTimer = setInterval(()=>{context.state.socket.emit("ping")},context.state.pingEvery)
                        context.state.socket.on('reconnecting', (attemptNumber) => {console.log("reconnecting ",attemptNumber)});
                        context.state.socket.on('reconnect_error', (error) => {});
                        context.state.socket.on("ping",()=>{})
                        context.state.socket.on("pong",(latency)=>{context.commit("SET_Latency",latency)})
            
                    })
            
                    context.state.socket.on('disconnect',(reason)=>{
                        context.state.socket.off("reconnecting")
                        context.state.socket.off("reconnect_error")
                        context.state.socket.off("ping")
                        context.state.socket.off("pong")
                        clearInterval(context.state.pingTimer)
                        context.dispatch("setConnectionStatus",false)
                    
                    })
                }
                else{
                    console.log("Issue with getToken ")
                    console.log(token)
                }

            }//end if not connected
                
        } catch (error) {
           console.log("Connection Error") 
           console.log(error)
        }
           
    },
    async getToken (context,info){
        
        try {
            
            const request =`${context.state.serverURL}/getToken`
            // console.log("Value Of geToken Request  ", request)
            const response = await axios.post(request,info)
            
            
            let token = response.data    
            return token
        
          } catch (error) {
            console.log(error)
            throw "getToken() "+error;
          }
    
    },
    disconnect(context,payload){
        
        if(context.state.socket){
           
             context.state.socket.disconnect()
            //  context.commit("SET_Connected",false)
            //  clearInterval(context.state.pingTimer)
        }

    }

}

export const getters = {
    getConnectionStatus:(state)=>{
        // console.log("getConnectionStatus ",state.connected)
        return state.connected
    },
    getConnection:(state)=>{
    
        return state.socket
    }
}

/*

{dispatch: ƒ, commit: ƒ, getters: {…}, state: {…}, rootGetters: {…}, …}
commit: ƒ (_type, _payload, _options)
dispatch: ƒ (_type, _payload, _options)
getters: {}
rootGetters: {…}
rootState: {__ob__: Observer}
state: {__ob__: Observer}

*/